/* ** *** *** ***
Covetrus PCI/Security Notice:
This file has been identified as potentially impacting user and/or data security.
All modifications to these files must be reviewed and merged by a designated Security Champion for this application.
Additional information, including specifics for Pull Requests, can be found here:
https://dvmwiki.atlassian.net/wiki/spaces/MCT/pages/507511182/Code+Reviews
*** *** *** ** */

import { connect } from 'react-redux';

import getStatesOption from '../../actions/stateOptions/setStatesOption';
import placeOrder from '../../actions/order/placeOrder';
import enableCreditCardInfoModal from '../../actions/modals/enableCreditCardInfoModal';
import enableShippingAddressModal from '../../actions/modals/enableShippingAddressModal';
import enableCreditCardList from '../../actions/modals/enableCreditCardList';
import CartPageLayout from './CartPageLayout';
import sendPaymentDataToAnet from '../../actions/order/authNet';

export default connect(
  ({ userInfo }) => ({
    defaultPaymentOption: userInfo.defaultPaymentOption,
    ccNum: (userInfo.defaultPaymentOption || {}).creditCardNumber || '',
    customer: userInfo.customer,
    product: userInfo.product,
    priceInformation: userInfo.priceInformation,
    prescription: userInfo.prescription,
    shippingAddress: (userInfo.customer || {}).shippingAddress,
    cvcNumber: (userInfo.defaultPaymentOption || {}).cvcNumber,
    billingType: userInfo.billingType,
    shipToType: userInfo.shipToType,
  }),
  {
    getStatesOption,
    handlePlaceOrder: placeOrder,
    handleAuthNetPayment: sendPaymentDataToAnet,
    handleEditCCInfo: enableCreditCardInfoModal,
    handleEditShipping: enableShippingAddressModal,
    handleEditCreditCardList: enableCreditCardList,
  }
)(CartPageLayout);



// WEBPACK FOOTER //
// ./src/containers/CartPage/CartPage.js